import React from "react";
import styled from "styled-components";
import { sify, tify } from "chinese-conv";
import { getData } from "common-lib/lib";
import BREAKPOINT from "../../config/breakpoint";
import { getQuery } from "lib";

const GameNameWrapper = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  /* justify-content: center; */
  /* flex-direction: column; */
  top: 0;
  width: ${(props) =>
    props.windowDimensions.width >= BREAKPOINT
      ? "calc(100% - 100px)"
      : "calc(100% - 70px)"};
  padding: ${(props) =>
    props.windowDimensions.width >= BREAKPOINT ? "0 50px" : "0 35px"};
  height: 70px;
  background-color: #000000de;
  /* border-bottom: 1px solid #3f3f3f; */
  /* background-color: ${(props) => props.theme.colors.bar}; */
  ::after {
    content: "";
    position: absolute;
    bottom: 0;
    height: 2px;
    width: ${(props) =>
      props.windowDimensions.width >= BREAKPOINT
        ? "calc(100% - 100px)"
        : "calc(100% - 70px)"};
    background-color: #3f3f3f;
  }
  & p {
    font-size: 28px;
    color: ${(props) => props.theme.colors.barText};
    font-weight: bold;
    text-shadow: 0px 1px 0 rgba(0, 0, 0, 0.38);
    width: 80%;
  }
`;

const GameName = ({ helpData, windowDimensions, lang }) => {
  const originGameId = getQuery("gameid");
  const extraGameNameList = {
    VPTWS32_1:{
      "zh-tw": "黄金王牌 2",
      "cn": "黄金王牌 2",
      "en": "Golden Ace 2",
      "vn": "Át Vàng 2",
      "th": "โกลเด้นเอซ 2",
      "ko": "골든 에이스 2",
      "ja": "ゴールデンエース 2",
    }
  }
  const gameName = () => {
    let result =
      lang === "zh-tw"
        ? tify(
            getData(helpData, ["game_name", "tw"]) ||
              getData(helpData, ["game_name", "zh-tw"])
          )
        : lang === "cn"
        ? sify(getData(helpData, ["game_name", "cn"]))
        : getData(helpData, ["game_name", lang?.toLowerCase()]) ||
          getData(helpData, ["game_name", "en"]) ||
          sify(getData(helpData, ["game_name", "cn"]));
    if (
      originGameId === "VPTWS04_1" &&
      (result === "充電寶" || result === "充电宝")
    ) {
      result = result.substring(result.length - 2);
    } else if (
      originGameId === "VPTWS28_1" &&
      (result === "麻将开胡" || result === "麻將開胡")
    ) {
      result = "麻將爆胡";
    } else if (
      originGameId === "VPTWS34_1" &&
      (result === "麻将开胡 3" || result === "麻將開胡 3")
    ) {
      result = "麻將爆胡 3";
    } else if (originGameId === "VPTWS32_1") {
      result = extraGameNameList?.[originGameId]?.[lang];
    }
    return lang === "zh-tw"
      ? tify(result)
      : lang === "cn"
      ? sify(result)
      : result;
  };
  return (
    getData(helpData, ["game_title"]) &&
    getData(helpData, ["game_name"]) && (
      <GameNameWrapper windowDimensions={windowDimensions}>
        {getData(helpData, ["game_name", lang?.toLowerCase()]) && (
          <p>{gameName()}</p>
        )}
      </GameNameWrapper>
    )
  );
};

export default GameName;
